import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "demand" };
import { onMounted, ref, onUnmounted } from 'vue';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import DemandCalendar from "../components/DemandCalendar.vue";
import config from "../services/PortalConfig";
import demandRepository from "../services/DemandRepository";
import demandUpdateListener from "../services/CustomerDemandUpdateListener";
import log from "@astina/paloma-common-ui/src/services/Logger";
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
const RELOAD_DEBOUNCE_MS = 600;
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandView',
    setup(__props) {
        const calendarData = ref(null);
        const initialSearchRequest = { size: config.demand.pageSize, sort: 'position' };
        const searchRequest = ref(initialSearchRequest);
        const searchFilters = ref([]);
        onMounted(loadDemandCalendarData);
        onMounted(loadCatalogFilters);
        onMounted(initUpdateListener);
        onUnmounted(stopUpdateListener);
        function loadDemandCalendarData() {
            demandRepository
                .getCalendarData(searchRequest.value)
                .then(data => calendarData.value = data);
        }
        function loadCatalogFilters() {
            productRepository.listFilters()
                .then(data => searchFilters.value = data);
        }
        function onSearchRequestUpdate(request) {
            searchRequest.value = { ...request, ...initialSearchRequest };
            loadDemandCalendarData();
        }
        // Debounced updates from purchases, notifications or received entries.
        let reloadTimer = null;
        function scheduleReload() {
            if (reloadTimer) {
                clearTimeout(reloadTimer);
            }
            reloadTimer = setTimeout(() => {
                reloadTimer = null;
                loadDemandCalendarData();
            }, RELOAD_DEBOUNCE_MS);
        }
        function initUpdateListener() {
            demandUpdateListener.init((demandItem) => {
                if (!calendarData.value) {
                    return;
                }
                const variantDto = calendarData.value.variants.content.find(variant => variant.variant.sku === demandItem.sku);
                if (!variantDto) {
                    log(`Ignoring demand update for SKU ${demandItem.sku} not in current calendar`);
                    return;
                }
                log(`Scheduling demand calendar reload due to update for SKU ${demandItem.sku}`);
                scheduleReload();
            });
        }
        function stopUpdateListener() {
            if (reloadTimer) {
                clearTimeout(reloadTimer);
                reloadTimer = null;
            }
            demandUpdateListener.stop();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !calendarData.value
                }, null, 8, ["loading"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (calendarData.value)
                    ? (_openBlock(), _createBlock(DemandCalendar, {
                        key: 0,
                        data: calendarData.value,
                        "search-request": searchRequest.value,
                        "search-filters": searchFilters.value,
                        onSearchRequestUpdate: onSearchRequestUpdate
                    }, null, 8, ["data", "search-request", "search-filters"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
